/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoFortnoxInvoiceRowDto } from './WebApiIntegrationsDtoFortnoxInvoiceRowDto';
import {
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSON,
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSONTyped,
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoToJSON,
} from './WebApiIntegrationsDtoFortnoxInvoiceRowDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateFortnoxInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    memberId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    printTemplate?: string | null;
    /**
     * VAT percentage for the (legacy single) row. Defaults to 0 (momsfri) when null - membership
     * fees are normally VAT-exempt and we never fall through to Fortnox's 25 % predefined rate.
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    vat?: number | null;
    /**
     * Optional Fortnox article for the legacy single row.
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    articleNumber?: string | null;
    /**
     * Optional Fortnox account override for the legacy single row.
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    accountNumber?: number | null;
    /**
     * Optional invoice due date. Null => Fortnox default (invoice date + 30 days).
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * Optional invoice date. Null => today.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    invoiceDate?: Date | null;
    /**
     * Invoice lines. When non-empty this is used and the scalar description /
     * amount / Vat / ArticleNumber /
     * AccountNumber are ignored. Those scalars are the legacy single-line form.
     * @type {Array<WebApiIntegrationsDtoFortnoxInvoiceRowDto>}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    rows?: Array<WebApiIntegrationsDtoFortnoxInvoiceRowDto> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateFortnoxInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateFortnoxInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    return WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'printTemplate': !exists(json, 'printTemplate') ? undefined : json['printTemplate'],
        'vat': !exists(json, 'vat') ? undefined : json['vat'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSON)),
    };
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateFortnoxInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'memberId': value.memberId,
        'amount': value.amount,
        'connectedYear': value.connectedYear,
        'printTemplate': value.printTemplate,
        'vat': value.vat,
        'articleNumber': value.articleNumber,
        'accountNumber': value.accountNumber,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(WebApiIntegrationsDtoFortnoxInvoiceRowDtoToJSON)),
    };
}

